<template>
    <transition-group name="list" tag="div" class="error-messages">
        <template v-for="(error, index) in errors">
            <div
                v-if="!validation[error]"
                :key="`${error}-${index}`"
                class="error-message"
            >
                <span v-if="error === 'required'">
                    {{ label }} is required
                </span>

                <span v-else-if="error === 'email'">
                    Not a valid email address
                </span>

                <span v-else-if="error === 'minLength'">
                    Must be at least
                    {{ validation.$params.minLength.min }} characters
                </span>

                <span v-else-if="error === 'maxLength'">
                    Must be less than
                    {{ validation.$params.maxLength.max + 1 }} characters
                </span>

                <span v-else-if="error === 'minValue'">
                    Must be at least {{ validation.$params.minValue.min }}
                </span>

                <span v-else-if="error === 'maxValue'">
                    Must be less than {{ validation.$params.maxValue.min }}
                </span>

                <span v-else-if="error === 'alpha'">
                    Must be letters only
                </span>

                <span v-else-if="error === 'numeric'"> Must be numeric </span>

                <span v-else-if="error === 'integer'">
                    Must be an integer
                </span>

                <span v-else-if="error === 'phone'">
                    Must be a valid phone number: 555-555-1234
                </span>

                <span v-else-if="['state', 'state1'].includes(error)">
                    Must be a valid state code: AZ, NV, etc
                </span>
            </div>
        </template>
    </transition-group>
</template>

<script>
export default {
    name: 'ErrorMessages',

    props: {
        validation: {
            type: Object,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    },

    computed: {
        errors() {
            return Object.keys(this.validation.$params);
        },
    },
};
</script>

<style lang="scss" scoped>
.error-messages {
    padding-top: 5px;
    color: $color-error;
}
</style>
